<div class="chip-value">
  <img class="chip-value__icon" *ngIf="config.icon" [src]="config.icon">

  <div class="chip-value__text">
    <span class="chip-value__value">{{ value.value }}</span>
    <span *ngIf="value.description" class="chip-value__description">{{ value.description }}</span>
  </div>

  <button *ngIf="removalAllowed" matChipRemove>
    <mat-icon>highlight_off</mat-icon>
  </button>
</div>
